import { GenericCollectionFactory } from "../../_generics";
import { GENERIC_IDS } from "../../_constants/generics.constants";

export const ClockinUsersStore = GenericCollectionFactory(
    GENERIC_IDS.CLOCKINS_USERS,
    "uid",
);